var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2Gray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368 85",
    style: {
      enableBackground: "new 0 0 368 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4E75;}\n\t.st1{fill:#3DB12B;}\n\t.st2{fill:#47AF2E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.8,70.5L75.5,60.1H56.7V51h21.6V11.1c0-1.1-0.9-2-2-2H38.4c-1.1,0-2,0.9-2,2V51H44v9.1H33.4 c-3.3,0-6.1-2.7-6.1-6.1V8c0.1-4.4,3.7-8,8.1-8h43.9c4.5,0,8.1,3.6,8.1,8.1v39.7L97.8,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,39.4v30.2c0,4.5-3.6,8.1-8.1,8.1H18.8L0,85l8.7-15V39.4c0-4.5,3.6-8.1,8.1-8.1h8.6v9.1h-6.6 c-0.6,0-1,0.5-1,1v27.1H45c0.6,0,1-0.5,1-1v-26c0-0.6-0.5-1-1-1h-6.9v-9.1H47C51.4,31.4,55.1,35,55.1,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,43.9c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S68.5,42.5,68.5,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.9,43.9c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S75.9,42.5,75.9,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,43.9c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S61.3,42.5,61.3,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.3,53.6h-10.2l-7-25.8l-7,25.8H121l-12.2-38.4h10.4l7,25.8l7-25.8h9.6l7,25.8l7-25.8h10.4L155.3,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.5,24.7c8.4,0,14.3,5.9,14.3,14.4c0,1-0.1,2.1-0.2,3h-19.3c0.7,3,3.6,4.9,7.4,4.9c2.3,0,5-0.8,7.8-2.3 l3,6.7c-4.3,2-8.5,2.9-12,2.9c-9.6,0-16.2-6.1-16.2-14.8C166.2,30.8,172.5,24.7,181.5,24.7z M176.3,36.2h9.9 c-0.3-2.5-2.2-4.2-4.7-4.2C178.9,32,176.9,33.7,176.3,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.9,44.1c0,1.4,0.9,2.2,2.3,2.2c0.7,0,1.5-0.1,2.3-0.2l1,7.5c-2.1,0.5-4.1,0.7-5.9,0.7 c-6,0-9.8-3.6-9.8-9.2V13.4h10L209.9,44.1L209.9,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228,44.1c0,1.4,0.9,2.2,2.3,2.2c0.7,0,1.5-0.1,2.3-0.2l1,7.5c-2.1,0.5-4.1,0.7-5.9,0.7c-6,0-9.8-3.6-9.8-9.2 V13.4h10L228,44.1L228,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.3,53.6h-10.2l-7-25.8l-7,25.8H246l-12.2-38.4h10.4l7,25.8l7-25.8h9.6l7,25.8l7-25.8h10.4L280.3,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.4,12.2c3.4,0,5.8,2.4,5.8,5.8c0,3.3-2.4,5.7-5.8,5.7c-3.3,0-5.7-2.4-5.7-5.7 C294.7,14.6,297.1,12.2,300.4,12.2z M295.4,25.4h10v28.3h-10V25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.1,24.7c3.5,0,7.3,0.7,11.1,2.1l-2.1,7.1c-2.9-1.1-5.7-1.8-8.2-1.8c-1.8,0-2.8,0.7-2.8,1.8 c0,3.4,14,0,14,11.1c0,5.4-4.9,9.4-12,9.4c-3.8,0-7.8-0.7-12-2.3l2.1-7.1c3.3,1.4,6.3,2.1,9.1,2.1c1.9,0,3-0.8,3-2 c0-3.5-14-0.2-14-11.1C310.2,28.6,315.1,24.7,322.1,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,24.7c8.4,0,14.3,5.9,14.3,14.4c0,1-0.1,2.1-0.2,3h-19.3c0.7,3,3.6,4.9,7.4,4.9c2.3,0,5-0.8,7.8-2.3 l3,6.7c-4.3,2-8.5,2.9-12,2.9c-9.6,0-16.2-6.1-16.2-14.8C337.2,30.8,343.5,24.7,352.4,24.7z M347.2,36.2h9.9 c-0.3-2.5-2.2-4.2-4.7-4.2C349.8,32,347.8,33.7,347.2,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168,65.3h9.5v2h-6.8v3.5h6.1v1.9h-6.1v3.9h7.1v2H168V65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.1,68.9h2.1l0.3,1.3c0.8-1,2-1.6,3.3-1.6c1.5,0,2.7,0.7,3.3,1.8c0.9-1.1,2.2-1.8,3.7-1.8 c2.2,0,3.8,1.5,3.8,3.5v6.4h-2.7v-6c0-1.1-0.8-1.9-2-1.9c-1.3,0-2.3,1-2.3,2.4v5.5H187v-6c0-1.1-0.8-1.9-2-1.9 c-1.4,0-2.3,1-2.3,2.4v5.5H180v-9.6H180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.2,68.9h2.1l0.3,1.2c0.7-0.9,1.9-1.5,3.3-1.5c2.7,0,4.7,2.1,4.7,5.1s-1.9,5.1-4.7,5.1 c-1.2,0-2.3-0.5-3.1-1.3v5.2h-2.7L199.2,68.9L199.2,68.9z M204.2,70.6c-1.4,0-2.4,1-2.4,2.4v1.3c0,1.4,1,2.4,2.4,2.4 c1.6,0,2.7-1.3,2.7-3.1C206.8,71.9,205.7,70.6,204.2,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.3,75.8c0,0.6,0.4,1,1,1c0.2,0,0.6-0.1,0.9-0.1l0.3,1.9c-0.7,0.1-1.3,0.2-1.8,0.2c-1.9,0-3.1-1.1-3.1-2.7 V64.6h2.7L214.3,75.8L214.3,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.6,68.6c3.2,0,5.5,2.1,5.5,5.1s-2.3,5.1-5.5,5.1s-5.5-2.1-5.5-5.1S219.4,68.6,222.6,68.6z M222.6,76.8 c1.6,0,2.8-1.3,2.8-3.1c0-1.8-1.2-3.1-2.8-3.1s-2.8,1.3-2.8,3.1S221,76.8,222.6,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,79.6c-0.9,2.2-2.2,3.3-4.1,3.3c-0.4,0-1-0.1-1.6-0.2l0.4-2c0.4,0.1,0.7,0.1,1,0.1c0.9,0,1.5-0.5,1.9-1.6 l0.4-0.8l-4.2-9.6h2.8l2.6,6.8l2.6-6.8h2.8L235,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.5,68.6c2.9,0,4.9,2,4.9,4.9c0,0.3,0,0.6,0,0.8H243c0.2,1.5,1.5,2.6,3.2,2.6c0.9,0,1.9-0.3,2.9-0.8 l0.8,1.7c-1.4,0.7-2.9,1-4.1,1c-3.3,0-5.5-2.1-5.5-5.1C240.3,70.7,242.4,68.6,245.5,68.6z M242.9,72.8h4.9c-0.1-1.4-1-2.3-2.3-2.3 C244.1,70.5,243.1,71.4,242.9,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.9,68.6c2.9,0,4.9,2,4.9,4.9c0,0.3,0,0.6,0,0.8h-7.4c0.2,1.5,1.5,2.6,3.2,2.6c0.9,0,1.9-0.3,2.9-0.8 l0.8,1.7c-1.4,0.7-2.9,1-4.1,1c-3.3,0-5.5-2.1-5.5-5.1C251.7,70.7,253.8,68.6,256.9,68.6z M254.4,72.8h4.9c-0.1-1.4-1-2.3-2.3-2.3 C255.5,70.5,254.5,71.4,254.4,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.4,78.6h-2.7l-3.1-10.1l-3.1,10.1h-2.7l-4.4-13.3h2.8l3.1,10.1l3.1-10.1h2.6l3.1,10.1l3.1-10.1h2.8 L283.4,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.1,68.6c2.9,0,4.9,2,4.9,4.9c0,0.3,0,0.6,0,0.8h-7.4c0.2,1.5,1.5,2.6,3.2,2.6c0.9,0,1.9-0.3,2.9-0.8 l0.8,1.7c-1.4,0.7-2.9,1-4.1,1c-3.3,0-5.5-2.1-5.5-5.1S290,68.6,293.1,68.6z M290.5,72.8h4.9c-0.1-1.4-1-2.3-2.3-2.3 C291.7,70.5,290.7,71.4,290.5,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.6,75.8c0,0.6,0.4,1,1,1c0.2,0,0.6-0.1,0.9-0.1l0.3,1.9c-0.7,0.1-1.3,0.2-1.8,0.2c-1.9,0-3.1-1.1-3.1-2.7 V64.6h2.7V75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,75.8c0,0.6,0.4,1,1,1c0.2,0,0.6-0.1,0.9-0.1l0.3,1.9c-0.7,0.1-1.3,0.2-1.8,0.2c-1.9,0-3.1-1.1-3.1-2.7 V64.6h2.7V75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.4,64.6h2.7V70c0.7-0.8,1.8-1.3,3.1-1.3c2.7,0,4.7,2.1,4.7,5.1s-1.9,5.1-4.7,5.1c-1.3,0-2.5-0.5-3.3-1.5 l-0.3,1.2h-2.1v-14H312.4z M317.4,70.6c-1.4,0-2.4,1-2.4,2.4v1.3c0,1.4,1,2.4,2.4,2.4c1.6,0,2.7-1.3,2.7-3.1 C320.1,71.9,319,70.6,317.4,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.5,68.6c2.9,0,4.9,2,4.9,4.9c0,0.3,0,0.6,0,0.8H327c0.2,1.5,1.5,2.6,3.2,2.6c0.9,0,1.9-0.3,2.9-0.8 l0.8,1.7c-1.4,0.7-2.9,1-4.1,1c-3.3,0-5.5-2.1-5.5-5.1S326.4,68.6,329.5,68.6z M326.9,72.8h4.9c-0.1-1.4-1-2.3-2.3-2.3 C328.1,70.5,327.1,71.4,326.9,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.6,64.6c0.9,0,1.6,0.6,1.6,1.5s-0.7,1.5-1.6,1.5S336,67,336,66.1C336.1,65.2,336.7,64.6,337.6,64.6z  M336.3,68.9h2.7v9.7h-2.7V68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.7,68.9h2.1l0.3,1.4c0.8-1,2-1.6,3.5-1.6c2.3,0,4,1.5,4,3.7v6.2H349v-5.8c0-1.2-0.9-2-2.1-2 c-1.4,0-2.5,1-2.5,2.5v5.3h-2.7L341.7,68.9L341.7,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.9,78.4c0,2.6-2.3,4.5-5.5,4.5c-1.3,0-2.8-0.3-4.3-0.9l0.7-1.9c1.3,0.6,2.4,0.8,3.4,0.8c1.8,0,3-1,3-2.4 v-1c-0.7,0.9-1.8,1.3-3.1,1.3c-2.7,0-4.6-2.1-4.6-5.1s1.9-5.1,4.6-5.1c1.4,0,2.5,0.5,3.3,1.5l0.3-1.2h2.1v9.5H363.9z M358.9,76.8 c1.4,0,2.4-1,2.4-2.4v-1.3c0-1.4-1-2.4-2.4-2.4c-1.5,0-2.6,1.3-2.6,3.1C356.3,75.5,357.4,76.8,358.9,76.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2Gray);
export default __webpack_public_path__ + "static/media/Logo2Gray.a25e9235ab6e9bdb1774858021818ece.svg";
export { ForwardRef as ReactComponent };